import React, { useState } from "react";
import { ReactComponent as LogoIcon } from "../assets/images/logo/Logo.svg";
import { Link } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import Adminroutes, { AgentRoutes, SmallIcon } from "../routes";
import { Icon } from "../routes";
import { ReactComponent as CampaignReportIcon } from "../assets/icons/Campaign_Report.svg";

const Sidebar = (props) => {
  const [open, setOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);

  const { auth } = useAuth();

  // Get User id //
  const user = useAuth();
  const user_id = user.auth.user_details.id;
  const ReportList =["Campaign Report","Callback Report","Agent Report","Agent Activity Report","Campaign Customers","Invalid Data Reports","Live Call Report"];

  const permissions = auth?.permissions?.data || [];
  const hasLiveCallReport = permissions.some(
    (perm) => perm.codename === "cadmin_o_livecallreport"
  );

  let type = "";
  if (auth.roles?.includes("sys_admin")) {
    type = "admin";
  } else if (auth.roles?.includes("contact-admin")) {
    type = "admin"; // or "contact-admin" if you have separate routing
  } else {
    type = "agent";
  }

  const SidebarMenu = () => {
    let Menus = [];

    if (auth.roles?.includes("sys_admin")) {
      Menus = Adminroutes;
    } else if (auth.roles?.includes("contact-admin")) {
      // Filter only report-related menus
      Menus = Adminroutes.filter(menu =>
        menu.key.includes("_report") || menu.name.toLowerCase().includes("report")
      );
    } else {
      Menus = AgentRoutes;
    }

    const reportMenus = Menus.filter((menu) => {
      if (menu.secton !== "report") return false;
      if (menu.key === "live_call_report" && !hasLiveCallReport) return false;
      return true;
    });
    const reportNames = reportMenus.map((menu) => menu.name);
    const isReportsActive = reportNames.includes(props.currsidemenu);

    return (
      <>
        {Menus.map((Menu, index) => {
          if (Menu.secton === "report") return null;

          const isActive = props.currsidemenu === Menu.name;

          return (
            <Link
              to={type + "/" + Menu.path}
              key={index}
              className={`flex group rounded-lg px-2 py-2.5 cursor-pointer border-l-2 ${
                isActive
                  ? "bg-white/10 border-cyan-400"
                  : "border-transparent hover:bg-white/5"
              } text-gray-300 text-sm items-center gap-x-4 transition-colors duration-150
              ${Menu.gap ? "mt-9" : "mt-1"}`}
              onClick={() => props.setCurrsidemenu(Menu.name)}
            >
              <li className="flex rounded-md cursor-pointer text-gray-300 text-sm items-center gap-x-4 w-full">
                <button className="group rounded-xl text-white">
                  <Icon icon={Menu.icon} active={isActive} />
                </button>
                <span
                  className={`${
                    !open && "hidden"
                  } origin-left duration-200 text-l truncate`}
                >
                  {Menu.name}
                </span>
              </li>
            </Link>
          );
        })}

        {reportMenus.length > 0 && (
          <div className="text-left">
            <div className={`${open ? "mx-1" : "mx-0"} mt-4 mb-2 border-t border-white/10`} />

            <div
              onClick={() => setReportsOpen(!reportsOpen)}
              className={`flex group rounded-lg px-2 py-2.5 cursor-pointer select-none border-l-2
                ${isReportsActive ? "bg-white/10 border-cyan-400" : "border-transparent hover:bg-white/5"}
                text-gray-300 text-sm items-center gap-x-4 transition-colors duration-150`}
            >
              <li className="flex rounded-md cursor-pointer text-gray-300 text-sm items-center gap-x-4 w-full">
                <button className="group rounded-xl text-white">
                  <Icon icon={CampaignReportIcon} active={isReportsActive} />
                </button>
                <span
                  className={`${
                    !open && "hidden"
                  } origin-left duration-200 text-l uppercase tracking-wide text-xs font-semibold text-gray-400`}
                >
                  Reports
                </span>
                <div
                  className={`ml-auto ${reportsOpen ? "rotate-0" : "-rotate-90"} ${
                    open ? "" : "hidden"
                  } transform transition-transform duration-300`}
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="#949494ff"
                    strokeWidth="4"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </li>
            </div>

            {/* Dropdown Menu */}
            <div
              className={`text-white transform transition-all origin-top select-none overflow-hidden
                ${reportsOpen ? "max-h-[999px] opacity-100" : "max-h-0 opacity-0"}`}
            >
              {reportMenus.map((Menu, index) => {
                const isActive = props.currsidemenu === Menu.name;

                return (
                  <Link
                    to={type + "/" + Menu.path}
                    key={index}
                    className={`flex group rounded-lg px-2 py-2.5 cursor-pointer border-l-2 ${
                      isActive
                        ? "bg-white/10 border-cyan-400"
                        : "border-transparent hover:bg-white/5"
                    } text-gray-300 text-sm items-center gap-x-4 transition-colors duration-150 mt-1`}
                    onClick={() => props.setCurrsidemenu(Menu.name)}
                  >
                    <li className="flex rounded-md cursor-pointer text-gray-300 text-sm items-center gap-x-4">
                      <div className="relative inline-block group">
                        <button className="group rounded-xl text-white z-10">
                          <Icon icon={Menu.icon} active={isActive} />
                          {Menu.subIcon && (
                            <SmallIcon icon={Menu.subIcon} active={isActive} />
                          )}
                        </button>
                      </div>
                      <span
                        className={`${
                          !open && "hidden"
                        } origin-left duration-200 text-l truncate`}
                      >
                        {Menu.name}
                      </span>
                    </li>
                  </Link>
                );
              })}
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <aside
      className={`flex-shrink-0 relative ${props.sidebaropen ? "" : "hidden"} ${
        !open ? "w-20" : "w-64"
      } bg-sidenavbg border-r md:block`}
    >
      <img
        src={require("../assets/images/control.png")}
        className={`cursor-pointer absolute -right-3 mt-16 w-7 ring-sidenavbg
          rounded-full ${!open && "rotate-180"}`}
        onClick={() => setOpen(!open)}
      />
      <div className="flex flex-col h-full">
        <nav
          aria-label="Main"
          className="flex-1 px-2 py-4 space-y-1 overflow-y-hidden hover:overflow-y-auto no-scrollbar"
        >
          <div className="flex gap-x-4 items-center mb-[50px]">
            <LogoIcon className={`cursor-pointer duration-500`} />
            <h1
              className={`text-white origin-left font-medium text-xl duration-200 ${
                !open && "hidden"
              }`}
            >
              CONTACT CENTRE
            </h1>
          </div>
          <div>
            <ul>
              <SidebarMenu />
            </ul>
          </div>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
